import { render } from "./SaferManage.vue?vue&type=template&id=28ac27a8&scoped=true"
import script from "./SaferManage.vue?vue&type=script&lang=js"
export * from "./SaferManage.vue?vue&type=script&lang=js"

import "./SaferManage.vue?vue&type=style&index=0&id=28ac27a8&lang=scss&scoped=true"

import exportComponent from "/home/brant/git/HeySensCloudWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ac27a8"]])

export default __exports__